<template>
  <nav
    :class="[
      'nav-wrap',
      { fr: storeName.FR, de_s: storeName.DE_s, ee: storeName.EE },
    ]"
  >
    <transition name="fold" mode="out-in">
      <ul v-if="isMob ? (isFold ? false : true) : true">
        <li
          @mouseenter="!isMob && tabHover(item)"
          @mouseleave="!isMob && tabHover(item)"
          @click="isMob && tabHover(item)"
          v-for="item in navItems"
          :key="item.id"
        >
          <a
            :class="['nav-item', item.isActive ? 'active' : '']"
            :href="item.link"
            target="_blank"
          >
            <span>{{ item.name }}</span>
            <i
              v-if="(item.dropMenu && isMob) || (item.dropMenu && storeName.EE)"
              :class="['iconfont icon-xiala', item.isActive ? 'rever' : '']"
            ></i>
          </a>
          <!-- <i v-if="isMobile" :class="['iconfont', 'icon-xiala']"></i> -->

          <transition
            :name="
              isMob
                ? 'fold'
                : storeName.DE_s
                ? 'showMenu-pc'
                : storeName.EE
                ? 'fold1'
                : 'showMenu-pc'
            "
            mode="out-in"
          >
            <div v-show="item.dropMenu && item.isActive" class="drop-menu-wrap">
              <div v-if="item.dropMenu" class="drop-menu">
                <a
                  :href="i.link"
                  v-for="i in item.dropMenu.length > 4
                    ? item.dropMenu.slice(0, 5)
                    : item.dropMenu"
                  :key="i.id"
                  :class="[i.isActive ? 'active' : '']"
                  @mouseenter="tabHover(i)"
                  @mouseleave="tabHover(i)"
                >
                  {{ i.name }}
                </a>
              </div>
              <div
                v-if="item.dropMenu && item.dropMenu.length > 5"
                class="drop-menu"
              >
                <a
                  v-for="i in item.dropMenu.length > 9
                    ? item.dropMenu.slice(5, 10)
                    : item.dropMenu.slice(5)"
                  :href="i.link"
                  :key="i.id"
                  :class="[i.isActive ? 'active' : '']"
                  @mouseenter="tabHover(i)"
                  @mouseleave="tabHover(i)"
                >
                  {{ i.name }}
                </a>
              </div>

              <div
                v-if="item.dropMenu && item.dropMenu.length > 10"
                class="drop-menu"
              >
                <a
                  v-for="i in item.dropMenu.length > 14
                    ? item.dropMenu.slice(10, 15)
                    : item.dropMenu.slice(10)"
                  :href="i.link"
                  :key="i.id"
                  :class="[i.isActive ? 'active' : '']"
                  @mouseenter="tabHover(i)"
                  @mouseleave="tabHover(i)"
                >
                  {{ i.name }}
                </a>
              </div>
            </div>
          </transition>
        </li>
      </ul>
    </transition>

    <button v-if="isMob" @click="changeIsFold">
      <transition name="tab-opt" mode="out-in">
        <i v-if="isFold" class="iconfont icon-zhankai1" key="zhankai"></i>
        <i v-else class="iconfont icon-shouqi1" key="shouqi"></i>
      </transition>
    </button>

    <form
      v-if="search.isShow"
      :class="search.form.className"
      :action="search.form.action"
      autocomplete="off"
      method="get"
      target="_blank"
    >
      <button class="btn" type="submit">
        <i v-if="!storeName.EE" class="iconfont icon-fangdajing"></i>
        <span v-else-if="storeName.EE">Search</span>
      </button>
      <input
        :class="{ 'form-control': storeName.FR }"
        :placeholder="search.form.placeholder"
        name="_nkw"
        type="text"
        value=""
      />
    </form>
  </nav>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "main-nav",
  props: {
    navItems: {
      type: Array,
      required: true,
    },
    search: {
      type: Object,
      required: true,
    },
    isMob: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      isFold: true,
    };
  },
  computed: {
    ...mapState("storeInfo", ["storeName"]),
  },
  methods: {
    tabHover(tag) {
      tag.isActive = !tag.isActive;
      // !this.isMob ? (tag.isActive = !tag.isActive) : null;
    },
    changeIsFold() {
      this.isFold = !this.isFold;
      this.$emit("resetH");
    },
  },
};
</script>

<style lang="less" scoped>
.nav-wrap {
  @media (min-width: 576px) {
    .flex-wrap(space-between, center, wrap);
    position: relative;
    > ul {
      .inl-flex;
    }
    .nav-item {
      .iconfont {
        .ml(0.5em);
      }
    }
    form {
      .inl-flex;
      > .form-control {
        flex: 0 0 25%;
        .border-B;
      }
    }
    .drop-menu-wrap {
      position: absolute;
      z-index: 100;
      left: 0;
      right: 0;
      .flex-wrap(initial, initial, wrap);
      background-color: #fff;
      .shadow;
      .border-T(#7e7f84);

      > .drop-menu {
        flex: 0 0 15%;
        .flex-wrap(initial, initial, wrap, column);
        .my;
        .mx(2rem);
        &:not(:last-child) {
          .border-R(@neutralPlaceholderColor);
        }
      }
      a {
        .lh(2rem);
        .fz(2em);
        &.active {
          text-decoration: underline;
          color: @primaryColor;
        }
      }
    }
  }
  @media (max-width: 576px) {
    position: relative;
    align-self: stretch;
    .flex-wrap(initial, initial, initial, column);
    > button {
      position: absolute;
      top: 1rem;
      right: 1rem;
      .bg-c;
      .radius;
      &:active {
        .bg-c(@primaryActive);
      }
      > .iconfont {
        .mt(2px);
        .fz(0.8rem);
      }
    }
    > ul {
      overflow: hidden;
      .border-T;
      .bg-c(rgba(0, 0, 0, 0.8), #fff);
      > li {
        .fz(0.8rem);
        > .nav-item {
          .flex-wrap(space-between);
          .px(1.5rem);
          .icon-xiala {
            .gd;
          }
        }
        .drop-menu-wrap {
          .drop-menu {
            .my;
            .ml(2.5rem);
            float: left;
            .flex-wrap(initial, initial, initial, column);
            color: @neutralColor;
            > a {
              .lh(1.8rem);
              &:active {
                color: @primaryColor;
              }
            }
          }
          overflow: hidden;
          .clearfix;
          .bg-c(@secondaryColor);
        }
        &:first-child {
          .mt;
        }
        &:last-child {
          .mb;
        }
      }
      order: 1;
    }
    form {
      .inl-flex(center);
      .my;
      width: 50%;
    }
  }
  .nav-item {
    .t-t(uppercase);
    .fw(500);
    .lh;
    .fz(12px);
    &.active {
      color: @primaryColor;
    }
  }
  .drop-menu-wrap {
    overflow: hidden;
  }
  .drop-menu {
    a {
      .t-t;
    }
  }
  form {
    .btn {
      .fz(1rem);
      .cur;
    }
  }

  // fr========================
  &.fr {
    &::before {
      content: "";
      display: block;
      .border-T(#eee);
      .wh(100%, auto);
    }
    @media (min-width: 576px) {
      > ul {
        > li {
          color: #7e7f84;
          &:first-child {
            .pr;
          }
          &:not(:first-child) {
            .px;
          }
        }
      }
      > button {
        .lh(1.4rem);
      }
    }
    @media (max-width: 576px) {
      > button {
        .py(0.3em);
      }
      form {
        > .btn {
          order: 1;
        }
        > input {
          .bg-c();
          .radius(5px);
          text-indent: 1em;
          &::-webkit-input-placeholder {
            color: #fff;
          }
          flex: 0 0 40%;
        }
        .mx(auto);
      }
    }
    form {
      flex: 1;
      .btn {
        color: @primaryColor;
      }

      .form-control {
        width: 0;
        &:focus {
          flex: 1;
        }
        &::after {
          content: "";
          display: block;
          .wh;
          .border;
        }
      }
    }
  }

  // de_s======================
  &.de_s {
    @media (min-width: 576px) {
      // .border-B(@neutralPlaceholderColor);
      .shadow(@neutralPlaceholderColor, 0, 3px);
      .mx(110px);
      > ul {
        > li {
          .px(1.5rem);
          > a {
            .lh(60px);
          }
          .border-L(#eee);
          .lh(2.5rem);
          &:last-child {
            .border-R(#eee);
          }
        }
      }
      //暂时留住注释=========
      // .drop-menu-wrap {
      // right: 30%;
      // > .drop-menu {
      //   flex: 0 0 25%;
      // }
      // }
      //暂时留住注释=========
      .nav-item {
        .t-t;
        color: @neutralColor;
        &.active {
          text-decoration: underline;
          color: @primaryColor;
        }
      }
      form {
        > input {
          .fz(1em);
        }
        .gd(0.6s);
        &:focus-within {
          .border;
          .shadow(@primaryColor);
        }
        .mr;
      }
    }
    @media (max-width: 576px) {
      form {
        .ml;
        justify-content: flex-start;
        > input {
          .fz(0.8rem);
        }
      }
      .drop-menu {
        > a {
          text-decoration: underline;
        }
      }
    }

    > button {
      .py(0.6em);
      .px(1rem);
      .bg-c(transparent, @neutralColor);
      color: @primaryColor;
      // .border(@neutralColor);
      .shadow(@primaryColor);
    }
    form {
      overflow: hidden;
      flex: 0 0 20%;
      .py(0.6em);
      .pr;
      .border(#626262);

      .gd(0.6s);

      > input {
        .pl(1em);
        .border-L(#626262);
        // .fz(1em);
        align-self: center;
        &::-webkit-input-placeholder {
          color: #999;
        }
      }
      .iconfont {
        .gd(0.6s);
      }
      &:focus-within {
        .border;
        .shadow(@primaryColor);
        .iconfont {
          color: @primaryColor;
        }
      }
      .btn {
        color: #888;
        // .mx(4px);
      }
    }
  }

  // ee========================
  &.ee {
    background-color: @neutralColor;
    @media (min-width: 576px) {
      .px(2%);
      .drop-menu {
        flex: 0 0 20%;
      }
      form {
        .fz(1rem);
      }
      > ul {
        position: relative;
        > li {
          .mx;
        }
      }
      .nav-item {
        .fw(600);
        .fz(1rem);
        .lh(3rem);
        > .iconfont {
          .fz(0.5em);
        }
      }
    }
    @media (max-width: 576px) {
      .px;
      form {
        width: auto;
        justify-content: flex-start;
        input,
        button {
          .fz(0.8rem);
        }
        input {
          order: 2;
        }
      }
      > ul {
        background-color: transparent;
      }
      > button {
        .px;
        .py(0.4em);
        .fz(0.8rem);
      }
      .nav-item {
        .fz(0.8rem);
      }
      .drop-menu {
        .ml(1.5rem) !important;
      }
    }
    .nav-item {
      .gd;
      color: @neutralColorText;
      &.active {
        color: @primaryColor;
      }
    }
    form {
      > button,
      > input {
        .radius;
        .mr(0.5em);
      }
      > button {
        order: 1;
        .bg-c;
        .py(0.4em);
        .px(0.8rem);
        &:active {
          .bg-c(@primaryActive);
        }
      }
      > input {
        .px;
        background-color: @neutralColorText;
      }
    }
  }
}
</style>
